import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import VueApollo from 'vue-apollo'
import Vue from 'vue'

Vue.use(VueApollo)

export const httpLink = new HttpLink({
    // You should use an absolute URL here
    uri: 'https://api-us-east-1.graphcms.com/v2/ck72w2wfo7ujh01cy9e9z4nse/master',
})

// Create the apollo client
export const apolloClient = new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache(),
    connectToDevTools: true,
})

export const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
})


// WEBPACK FOOTER //
// ./src/apollo.js